{
  "metadata": {
    "id": "orng-dark",
    "name": "Orng",
    "description": "Портировано из темы «Orng» (dark)",
    "author": "OpenCode",
    "version": "2.0.0",
    "variant": "dark",
    "tags": [
      "dark",
      "ported"
    ],
    "source": {
      "file": "orng.json",
      "project": "opencode",
      "url": "https://github.com/anomalyco/opencode",
      "upstreamFile": "packages/ui/src/theme/themes/orng.json",
      "license": "MIT",
      "authoring": null
    },
    "validation": {
      "checks": 34,
      "fails": [],
      "paletteMinDeltaE": 25.3,
      "paletteTarget": 20.0,
      "paletteFloor": 18.0,
      "paletteAvgS": 0.466,
      "paletteMaxS": 0.511,
      "paletteAcid": 0,
      "surfacesMinDeltaE": 4.3,
      "surfacesTarget": 4.0,
      "surfacesRaisedTarget": 5.0,
      "surfacesAway": false,
      "syntaxMinDeltaE": 31.0,
      "syntaxVsTextMinDeltaE": 5.5,
      "chartsMinDeltaE": 36.3,
      "textSeparationDeltaE": 33.2,
      "textSeparationTarget": 10.0,
      "textSeparationFloor": 8.0,
      "textSeparationTinted": false,
      "authorialCollisions": [
        {
          "a": "function",
          "b": "operator",
          "deltaE": 0.0
        }
      ],
      "modeLabel": "dark",
      "modeFromLuminance": "dark",
      "paletteIdenticalToPeer": false
    }
  },
  "colors": {
    "primary": {
      "base": "#EC5B2B",
      "hover": "#ee6f44",
      "active": "#f07c55",
      "foreground": "#000000",
      "muted": "#ec5b2b80",
      "emphasis": "#EC5B2B"
    },
    "surface": {
      "background": "#0a0a0a",
      "foreground": "#eeeeee",
      "muted": "#232323",
      "mutedForeground": "#939393",
      "elevated": "#2c2c2c",
      "elevatedForeground": "#eeeeee",
      "raised": "#474747",
      "raisedForeground": "#eeeeee",
      "overlay": "#0a0a0acc",
      "subtle": "#191919"
    },
    "interactive": {
      "border": "#4a4a4a",
      "borderHover": "#4a4a4a",
      "borderFocus": "#EC5B2B",
      "selection": "#eeeeee29",
      "selectionForeground": "#eeeeee",
      "focus": "#ec5b2b59",
      "focusRing": "#ec5b2b61",
      "cursor": "#eeeeee",
      "hover": "#eeeeee1c",
      "active": "#eeeeee29"
    },
    "status": {
      "error": "#e06c75",
      "errorForeground": "#000000",
      "errorBackground": "#e06c7524",
      "errorBorder": "#e06c7573",
      "warning": "#EC5B2B",
      "warningForeground": "#000000",
      "warningBackground": "#ec5b2b24",
      "warningBorder": "#ec5b2b73",
      "success": "#6ba1e6",
      "successForeground": "#000000",
      "successBackground": "#6ba1e624",
      "successBorder": "#6ba1e673",
      "info": "#56b6c2",
      "infoForeground": "#000000",
      "infoBackground": "#56b6c224",
      "infoBorder": "#56b6c273"
    },
    "pr": {
      "open": "#6ba1e6",
      "draft": "#979797",
      "blocked": "#EC5B2B",
      "merged": "#FFF7F1",
      "closed": "#e06c75"
    },
    "syntax": {
      "base": {
        "background": "#2e2e2e",
        "foreground": "#eeeeee",
        "comment": "#979797",
        "keyword": "#ef7147",
        "string": "#6ba1e6",
        "number": "#FFF7F1",
        "function": "#56b6c2",
        "variable": "#e2747d",
        "type": "#e5c07b",
        "operator": "#56b6c2"
      },
      "tokens": {
        "commentDoc": "#979797",
        "stringEscape": "#56b6c2",
        "keywordImport": "#ef7147",
        "storageModifier": "#ef7147",
        "functionCall": "#56b6c2",
        "method": "#56b6c2",
        "variableProperty": "#56b6c2",
        "variableOther": "#e2747d",
        "variableGlobal": "#FFF7F1",
        "variableLocal": "#56b6c2",
        "parameter": "#e2747d",
        "constant": "#FFF7F1",
        "class": "#e5c07b",
        "className": "#e5c07b",
        "interface": "#e5c07b",
        "struct": "#e5c07b",
        "enum": "#e5c07b",
        "typeParameter": "#e5c07b",
        "namespace": "#e5c07b",
        "module": "#ef7147",
        "tag": "#ef7147",
        "jsxTag": "#ef7147",
        "tagAttribute": "#56b6c2",
        "tagAttributeValue": "#6ba1e6",
        "boolean": "#FFF7F1",
        "decorator": "#ef7147",
        "label": "#56b6c2",
        "regexp": "#6ba1e6"
      }
    },
    "charts": {
      "series": [
        "#EC5B2B",
        "#56b6c2",
        "#6ba1e6",
        "#ec9b2b",
        "#e06c75"
      ]
    },
    "chat": {
      "background": "#0a0a0a",
      "userMessage": "#eeeeee",
      "userMessageBackground": "#2c2c2c",
      "assistantMessage": "#eeeeee",
      "assistantMessageBackground": "#232323",
      "timestamp": "#979797",
      "divider": "#4a4a4a",
      "typing": "#979797"
    },
    "loading": {
      "spinner": "#EC5B2B",
      "spinnerTrack": "#232323",
      "skeleton": "#232323",
      "shimmer": "#3a3a3a"
    },
    "tools": {
      "background": "#232323",
      "border": "#4a4a4a",
      "headerHover": "#383838",
      "icon": "#EC5B2B",
      "title": "#eeeeee",
      "description": "#979797",
      "edit": {
        "added": "#6ba1e6",
        "addedBackground": "#6ba1e624",
        "removed": "#e06c75",
        "removedBackground": "#e06c7524",
        "modified": "#56b6c2",
        "modifiedBackground": "#56b6c224",
        "lineNumber": "#979797"
      }
    },
    "markdown": {
      "heading1": "#eeeeee",
      "heading2": "#eeeeee",
      "heading3": "#eeeeee",
      "heading4": "#eeeeee",
      "link": "#EC5B2B",
      "linkHover": "#ee6f44",
      "inlineCode": "#6ba1e6",
      "inlineCodeBackground": "#232323",
      "blockquote": "#979797",
      "blockquoteBorder": "#4a4a4a",
      "listMarker": "#ec5b2bbf",
      "bold": "#eeeeee",
      "italic": "#eeeeeee6",
      "strikethrough": "#979797",
      "hr": "#4a4a4a"
    }
  },
  "palette": {
    "version": 1,
    "colors": [
      {
        "key": "a1",
        "name": "Красный",
        "hex": "#bf5943",
        "foreground": "#000000",
        "contrast": 4.73
      },
      {
        "key": "a2",
        "name": "Лососевый",
        "hex": "#dcb495",
        "foreground": "#000000",
        "contrast": 11.01
      },
      {
        "key": "a3",
        "name": "Янтарный",
        "hex": "#c4a850",
        "foreground": "#000000",
        "contrast": 9.06
      },
      {
        "key": "a4",
        "name": "Салатовый",
        "hex": "#aac755",
        "foreground": "#000000",
        "contrast": 11.01
      },
      {
        "key": "a5",
        "name": "Лаймовый",
        "hex": "#bfd89d",
        "foreground": "#000000",
        "contrast": 13.52
      },
      {
        "key": "a6",
        "name": "Светло-зелёный",
        "hex": "#53c551",
        "foreground": "#000000",
        "contrast": 9.47
      },
      {
        "key": "a7",
        "name": "Зелёный",
        "hex": "#58ba7e",
        "foreground": "#000000",
        "contrast": 8.74
      },
      {
        "key": "a8",
        "name": "Мятный",
        "hex": "#99ded1",
        "foreground": "#000000",
        "contrast": 13.72
      },
      {
        "key": "a9",
        "name": "Бирюзовый",
        "hex": "#4fabc2",
        "foreground": "#000000",
        "contrast": 7.94
      },
      {
        "key": "a10",
        "name": "Голубой",
        "hex": "#4d82b5",
        "foreground": "#000000",
        "contrast": 5.18
      },
      {
        "key": "a11",
        "name": "Синий",
        "hex": "#465fb1",
        "foreground": "#ffffff",
        "contrast": 5.95
      },
      {
        "key": "a12",
        "name": "Васильковый",
        "hex": "#4040b8",
        "foreground": "#ffffff",
        "contrast": 7.94
      },
      {
        "key": "a13",
        "name": "Фиолетовый",
        "hex": "#a169ca",
        "foreground": "#000000",
        "contrast": 5.39
      },
      {
        "key": "a14",
        "name": "Орхидея",
        "hex": "#d498cf",
        "foreground": "#000000",
        "contrast": 9.19
      },
      {
        "key": "a15",
        "name": "Пурпурный",
        "hex": "#bf4689",
        "foreground": "#ffffff",
        "contrast": 4.72
      },
      {
        "key": "a16",
        "name": "Розовый",
        "hex": "#c47082",
        "foreground": "#000000",
        "contrast": 5.99
      }
    ]
  }
}
